<template>
  <div class="content-wrappper ">
  <div class="regulation-main">
    <div class="col-md-12 regulation-header regulationBackground">
        <div class="pb-24">
          <p class="m-0 regulation_check">{{ $t('accounts') }}</p>
        </div>

    <div class="col-xs-12 p-0 ">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0 search-container-wraper search-outer">
            <div class="search-container reg-search col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 pr-24">
              <div style="position:relative">
                <search-box @updateStatusTable="updateAccountStatus" @updateDateInTable="updateDate" componentName="launchPadFilter" showFilter="true" :teamBorder='true' v-model="searchValue" :searchCount="searchCount" @getList="filterAccountsList()" :searchPlaceholder="$t('searchCompanyName')"></search-box>
              </div>
            </div>
        </div>
    </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 pl-25 pr-24 regulationBackground" >
      <div class="">
        <table class="table table-responsive registration-data" id="regulationDataList">

            <tr style="background-color: #E6E6E6; !important;">
              <th >
                <div class="tableHeader cursor-pointer" @click="companyArrowDirection = (-companyArrowDirection), sortBy('company_name', companyArrowDirection)">
                  <div class="ellipsis header-title" :title="$t('companyName')">{{$t('companyName')}}</div>
                  <div class="arrow" :class="companyArrowDirection === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th >
                <div class="tableHeader cursor-pointer" @click="usersArrowDirection = (-usersArrowDirection), sortNumbers('users_active', usersArrowDirection)">
                  <div class="ellipsis header-title" :title="$t('usersActive')">{{$t('usersActive')}}</div>
                  <div class="arrow" :class="usersArrowDirection === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th >
                <div class="tableHeader cursor-pointer" @click="nameArrowDirection = (-nameArrowDirection), sortBy('last_name', nameArrowDirection)">
                  <div class="ellipsis header-title" :title="$t('lastName')">{{$t('lastName')}}</div>
                  <div class="arrow" :class="nameArrowDirection === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th >
                <div class="tableHeader cursor-pointer" @click="accountIdArrowDirection = (-accountIdArrowDirection), sortNumbers('account_id', accountIdArrowDirection)">
                  <div class="ellipsis header-title" :title="$t('accountID')">{{$t('accountID')}}</div>
                  <div class="arrow" :class="accountIdArrowDirection === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th >
                <div class="tableHeader cursor-pointer" @click="accountStatusArrowDirection = (-accountStatusArrowDirection), sortBy('deactivated', accountStatusArrowDirection)">
                  <div class="ellipsis header-title" :title="$t('normType')">{{$t('normType')}}</div>
                  <div class="arrow" :class="accountStatusArrowDirection === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th style="width: 40px;"></th>
            </tr>

          <tbody ref="tbodyBox" v-if="accountsGridInfo.length&&!loaderStatus">
            <tr
            :class="index%2===0?'table_data_part1':'table_data_part2'"
            v-for="(account, index) in accountsGridInfo" :key="index">
              <td  class="ellipsis regulation-data"><span :title="account.company_name">{{ account.company_name }}</span></td>
              <td  class="ellipsis regulation-data"><span :title="account.users_active">{{ account.users_active }}</span></td>
              <td  class="ellipsis regulation-data"><span :title="account.last_name">{{ account.last_name }}</span></td>
              <td  class="ellipsis regulation-data"><span :title="account.account_id">{{ account.account_id }}</span></td>
              <td class="ellipsis regulation-data">
                <span v-if="account.deactivated">{{ $t('deactivated') }}</span>
                <span v-else>{{ $t('Active') }}</span>
              </td>
              <td style="width: 40px;">
                <template>
                  <div class="dropdown dropdown-export custom-three-dots three-dots p-0 ">
                    <div data-toggle="dropdown" class="d-flex justify-content-end">
                      <span class="dropdown-toggle cursor-pointer" data-toggle="tooltip" data-placement="right">
                        <img class="info-img" src="/static/images/icons/headlines_3_vertical_dots_menu.svg" />
                      </span>
                    </div>
                    <ul class="dropdown-menu tooltip-pointer dropdown-menu-ul">
                      <li class="p-0 pl-0">
                        <a :disabled="!account.deactivated" @click="openConfirmationPopup(account.account_id, 'activate', account.company_name)">
                          <span class="MRL-4 activate-text">{{ $t('activate') }}</span>
                        </a>
                      </li>
                      <li class="p-0 pl-0">
                        <a :disabled="account.deactivated" @click="openConfirmationPopup(account.account_id, 'deactivate', account.company_name)">
                          <span class="MRL-4 deactivate-text">{{ $t('deactivate') }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                    </template>
              </td>
             </tr>
          </tbody>
        </table>
        <div v-if="accountsGridInfo.length==0 && !loaderStatus">
              <p class="no-records-found">{{$t('noRecordsFound')}}</p>
            </div>
      </div>
    <div class="pagination-wrapper col-xs-12 col-sm-12 col-md-12" v-if="accountsGridInfo.length&&!loaderStatus">
      <pagination :totalPages="totalPages" :maxVisibleButtons="maxVisiblePages" :total="total" :perPage="perPage"
        :currentPage="currentPage" @pagechanged="pageChanged"></pagination>
    </div>
    </div>

    <delete-popup :deletewarnInfo="deleteWarningInfo" :headerTitle="headerTitle" :customMessage="customMessage"
      :customTitle="companyName" @dashboardPublishDelete="activateAccount()" from="launchpad">
    </delete-popup>
    <loader :loadingStatus="loaderStatus"></loader>
    </div>
</div>
</template>
<script>
import $ from 'jquery';
import SearchBox from '../UIComponents/ULSearchBox.vue';
import AccountsLeftFilter from './AccountsLeftFilter.vue';
import { getAccounts, activateAccount, deactivateAccount } from '../../apis/superAdmin';
import DeletePopup from '../UIComponents/DeleteRegHeadlinePopup.vue';
import Pagination from './Pagination.vue';
import Loader from '../UIComponents/Loader.vue';

export default {
  components: {
    SearchBox,
    AccountsLeftFilter,
    DeletePopup,
    Pagination,
    Loader,
  },
  data() {
    return {
      searchValue: '',
      searchCount: 0,
      companyArrowDirection: 1,
      usersArrowDirection: 1,
      nameArrowDirection: 1,
      accountIdArrowDirection: 1,
      accountStatusArrowDirection: 1,
      roleArrowDirection: 1,
      deleteWarningInfo: {
        loaderStatus: false,
        title: '',
      },
      accountId: '',
      accountType: '',
      activeStatus: true,
      deactivatedStatus: true,
      accountsData: { pagination: { from: 1, to: 50 }, filter: { account_status: { active: this.activeStatus, deactivated: this.deactivatedStatus }, date_created: { from: '', to: '' } }, search: '' },
      accountsGridInfo: [],
      totalPages: 1,
      total: 0,
      maxVisiblePages: 4,
      perPage: 50,
      currentPage: 1,
      fromRecords: 1,
      loaderStatus: false,
      customMessage: '',
      companyName: '',
      headerTitle: '',
    };
  },
  // mounted() {
  //   console.log(this.accountsGridInfo);
  // },
  async created() {
    await this.getAccounts();
  },
  methods: {
    async getAccounts(searchData) {
      this.loaderStatus = true;
      this.accountsData.filter.account_status.active = this.activeStatus;
      this.accountsData.filter.account_status.deactivated = this.deactivatedStatus;
      this.accountsData.pagination.from = this.fromRecords;
      this.accountsData.pagination.to = this.perPage;
      if (searchData) { this.accountsData.search = this.searchValue; }
      // const payload = { pagination: { from: 5027, to: 5078 }, filter: { account_status: { active: true, deactivated: true } } };
      const response = await getAccounts(this.accountsData);
      if (response.status_code === 200 && response.message === 'success') {
        this.accountsGridInfo = response.data.result_data;
        this.loaderStatus = false;
        // this.accountList = records.result_data;
        this.total = response.data.total_records_count;
        this.searchCount = this.total;
        this.totalRecordsCount = this.total > this.totalRecordsCount ? this.total : this.totalRecordsCount;
        this.totalPages = Math.ceil(this.total / this.perPage);
      } else if (response.message.includes(500)) {
        this.$router.push('layout/dashboard');
      }
    },
    async activateAccount() {
      const payload = { account_ids: [this.accountId] };
      const response = this.accountType === 'activate' ? await activateAccount(payload) : await deactivateAccount(payload);
      if (response.status_code === 200 && response.message === 'success') {
        this.deleteWarningInfo = {
          ...this.deleteWarningInfo,
          loaderStatus: false,
        };
        let validationMessage;
        if (this.accountType === 'activate') {
          validationMessage = this.$i18n.locale === 'Portuguese' ? `Conta "${this.companyName}" ativada com sucesso` : `Account "${this.companyName}" activated successfully`;
        } else {
          validationMessage = this.$i18n.locale === 'Portuguese' ? `Conta "${this.companyName}" desativada com sucesso` : `Account "${this.companyName}" deactivated successfully`;
        }
        $('#modal_delete').modal('hide');
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: validationMessage,
          group: 'custom-notification',
        });
        await this.getAccounts();
      }
    },
    async filterAccountsList() {
      await this.getAccounts('search');
    },
    openConfirmationPopup(id, type, companyName) {
      this.deleteWarningInfo.loaderStatus = false;
      if (this.$i18n.locale === 'English') {
        this.deleteWarningInfo.title = type === 'activate' ? 'You are about to activate the account' : 'You are about to deactivate the account';
        this.customMessage = type === 'activate' ? 'After activation this account will get full access to all data' : 'By deactivating this account you will also delete all data';
        this.headerTitle = type === 'activate' ? 'Activate Account' : 'Deactivate Account';
      }
      if (this.$i18n.locale === 'Portuguese') {
        this.deleteWarningInfo.title = type === 'activate' ? 'Você está prestes a ativar a conta' : 'Você está prestes a desativar a conta';
        this.customMessage = type === 'activate' ? 'Após a ativação, esta conta terá acesso total a todos os dados' : 'Ao desativar esta conta, você também excluirá todos os dados';
        this.headerTitle = type === 'activate' ? 'Ativar Conta' : 'Desativar conta';
      }
      this.accountId = id;
      this.accountType = type;
      this.companyName = companyName;
      $('#modal_delete').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    async updateAccountStatus(active, deactivated) {
      this.activeStatus = active;
      this.deactivatedStatus = deactivated;
      await this.getAccounts();
      // const payload = { pagination: { from: 1, to: 50 }, search: this.searchValue };
    },
    async updateDate(startDate, endDate) {
      this.accountsData.filter.date_created.from = startDate;
      this.accountsData.filter.date_created.to = endDate;
      await this.getAccounts();
    },
    async pageChanged(currentPage) {
      if (currentPage) this.currentPage = currentPage;
      this.fromRecords = this.currentPage * this.perPage - (this.perPage - 1);
      await this.getAccounts();
    },
    sortBy(type, direction) {
      // this.`${type}`="sadsa";

      if (direction === 1) this.accountsGridInfo.sort((a, b) => (a[type] > b[type] ? -1 : 1));
      else {
        this.accountsGridInfo.sort((a, b) => {
          const nameA = type !== 'deactivated' ? a[type]?.toUpperCase() : a[type]; // ignore upper and lowercase
          const nameB = type !== 'deactivated' ? b[type]?.toUpperCase() : b[type]; // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        });
      }

      // } else {
      //   this.dateArrowDirection = -(this.dateArrowDirection);
      //   if (this.dateArrowDirection === 1) {
      //     this.accountsGridInfo.sort((a, b) => new Date(b.display_date) - new Date(a.display_date));
      //   } else { this.accountsGridInfo.sort((a, b) => new Date(a.display_date) - new Date(b.display_date)); }
      // }
    },
    sortNumbers(type, direction) {
      if (direction === 1) this.accountsGridInfo.sort((a, b) => b[type] - a[type]);
      else this.accountsGridInfo.sort((a, b) => a[type] - b[type]);
    },
  },

};
</script>
<style>
.activate-deActivate-tooltip .el-dropdown-menu__item.is-disabled{
  color: #00518A;
  font-size: 16px;
}
.activate-deActivate-tooltip .el-dropdown-menu__item:not(.is-disabled),
.activate-deActivate-tooltip .el-dropdown-menu__item:not(.is-disabled):hover{
  color: #E12D33;
  font-size: 16px;
  background-color: unset;
}
.activate-deActivate-tooltip.el-dropdown-menu.el-popper {
  background: #FFFFFF;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25);
  filter: drop-shadow(0px 0px 10px #b2b2b2);
  border-radius: 5px;
  cursor: default;
  padding: 16px 0px 12px 16px !important;
  width: 157px !important;
  min-height: 92px !important;
  left: 1338px !important;
  /* top: 264px !important; */
  border-radius: 0px !important;
}

.activate-deActivate-tooltip .el-dropdown-menu__item {
  margin-top: 0px;
  padding: 0px;
  line-height: 30px;
}

.activate-deActivate-tooltip.el-popper[x-placement^=top] .popper__arrow {
  bottom: 0px;
  left: 0;
  margin-right: 0px;
  border-bottom-width: 0;
}

.activate-deActivate-tooltip.el-popper[x-placement^=top] .popper__arrow::after {
  bottom: -6px;
  margin-left: -15px;
  border-top-color: #fff;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.activate-deActivate-tooltip.el-popper[x-placement^=bottom] .popper__arrow {
  top: -6px;
  left: 0;
  margin-right: 0px;
  border-top-width: 0;
}

.activate-deActivate-tooltip.el-popper[x-placement^=bottom] .popper__arrow::after {
  top: 0px;
  margin-left: -14px;
  border-top-width: 0;
  border-bottom-color: #fff;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.activate-deActivate-tooltip.el-popper .popper__arrow {
  border-width: 0px;
}

.activate-deActivate-tooltip.el-popper .popper__arrow::after {
  content: " ";
  border-width: 7px;
}
</style>

<style scoped>
.table {
  margin-bottom: 0px;
}
.custom-three-dots {
  padding-right: 10px;
  padding-top: 5px;
}
.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: #ffffff;
  border-top: 1px solid #B3B3B3;
  border-bottom: 1px solid #B3B3B3;
}
.activate-text {
  color: #00518A;
  font-size: 16px;
}
.deactivate-text {
  color: #E12D33;
  font-size: 16px;
}
/* .edit-text {
  font-size: 16px;
  color: #4d4d4d;
} */
.tooltip-pointer li:first-child {
  padding-bottom: 10px;
}
.tooltip-pointer:before {
  position: absolute;
  top: -6px;
  height: 0;
  width: 0;
  /* left: 84%; */
  right: 4%;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 7px solid #ffffff;
  content: '';
}
.dropdown-menu-ul {
  /* left: -150px !important; */
  right: 7px !important;
  left: unset;
}
.dropdown-menu-ul::after {
  right: 1em !important;
}
.dropdown-menu {
  /* left: -15px; */
  min-width: 157px;
  height: 93px;
  filter: drop-shadow(0px 0px 10px #b2b2b2);
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  border: none;
  top: 42px !important;
  padding: 10px 0px 12px 4px;
  background: #ffffff;
}
.dropdown-menu > li > a {
  padding: 0px;
  display: flex;
  color: rgb(52, 17, 126);
}
.dropdown-menu > li > a:focus,
.dropdown-menu > li > a:hover {
  color: rgb(52, 17, 126);
}
.dropdown-menu .divider {
  margin: 0px;
}
.dropdown-export .export-menu li .MRL-4 {
  margin-left: 4px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #34117e;
}
.dropdown-export .export-menu li .MRR-4 {
  margin-right: 4px;
}
.dropdown-export .export-menu img,
.viewRegistration img {
  width: 18px;
  vertical-align: sub;
  height: 18px;
}
.dropdown-export .export-menu img.unarchive {
  height: 20px;
}
.dropdown-export .export-menu span {
  font-size: 14px;
}
.footer {
  text-align: right;
  padding-right: 25px;
  padding-bottom: 20px;
  background-color: #E5E5E5 !important;
}
.ul_finish_button,
.ul_finish_button:hover {
  background-color: #01518A;
  height: 34px;
  width: 123px;
  color: #FFFFFF !important;
  font-size: 16px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 22px;
  float: right;
  cursor: pointer;
  padding: 6px 20px 6px 16px;
}
.regulation-header {
  padding:24px 0px 0px 25px
}
.btn-todo-list,
.btn-todo-list:hover {
  background: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #01518A;
  /* padding-bottom: 4px; */
}
.table_data_part1{
  background-color: #FAFAFA;
}
.table_data_part2{
  background-color: #F5F5F5;
}
.pb-24 {
  padding-bottom: 24px;
}
.pb-14 {
  padding-bottom: 14px;
}
.header-title{
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
}
.regulation-data {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
  padding: 14px 0px 16px 12px !important;
}
.down-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #999999;
}

.up-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #999999;
}

.regulation-main{
    background-color: #E5E5E5 !important;
    height: calc(100vh - 50px) !important;
    min-height: 865px;
}
.regulation_check {
  font-weight: 400;
  font-size: 24px;
  line-height: 34px;
  color: #3E3E3E;
}
.tableHeader {
  display: flex;
  align-items: center;
  padding:14px 0px 12px 12px;
  column-gap: 7px
  /* justify-content: center; */
}
.regulationBackground {
  background-color: #EBEBEB;
}
#regulationDataList th .arrow {
  opacity: 1;
}
#regulationDataList thead,

#regulationDataList tbody,

#regulationDataList tr:not(#regulationDataList thead tr) {
 display: table;
 width: 100%;
table-layout: fixed;
}
</style>
